// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Upload icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the UploadIcon component.
 * @returns {ReactElement} The UploadIcon component.
 */
export const UploadIcon = (props: IconProps) => {
  const { color = '#4F5DBA', ...rest } = props;
  return (
    <Icon viewBox='0 0 9 10' width={2} color={color} {...rest}>
      <path
        d='M8.53125 6.24889C8.79004 6.24889 9 6.45885 9 6.71764V8.12389C9 9.15943 8.16055 9.99889 7.125 9.99889H2.125C1.08945 9.99889 0.25 9.15943 0.25 8.12389V6.71764C0.25 6.45787 0.459766 6.24889 0.71875 6.24889C0.977539 6.24889 1.1875 6.45885 1.1875 6.71764V8.12389C1.1875 8.63951 1.60938 9.06139 2.125 9.06139H7.125C7.64062 9.06139 8.0625 8.63951 8.0625 8.12389V6.71764C8.0625 6.45787 8.27148 6.24889 8.53125 6.24889ZM4.30469 0.1266L1.64844 2.60902C1.45859 2.80357 1.45 3.10045 1.62754 3.28795C1.80453 3.47654 2.10117 3.4856 2.28984 3.30809L4.15625 1.55279V6.40435C4.15625 6.6649 4.36719 6.87389 4.625 6.87389C4.88281 6.87389 5.09375 6.66393 5.09375 6.42271V1.55279L6.96016 3.30904C7.14875 3.48666 7.44531 3.4775 7.62246 3.28891C7.70703 3.1981 7.75 3.08287 7.75 2.96764C7.75 2.84312 7.70057 2.71861 7.6023 2.62642L4.94605 0.144003C4.76563 -0.0436926 4.48438 -0.0436926 4.30469 0.1266Z'
        fill='currentColor'
      />
    </Icon>
  );
};
